import React from "react";
import "../styles/main.css";
import bgi3 from "../assets/brandsimage.png";

export default function VFBr_WhyBroadcasters() {
return (
  <section className="w-full bg-black py-24 xl:py-20 lg:py-16 md:py-12 sm:py-10 px-24 xl:px-16 lg:px-10 md:px-8 sm:px-5">
    <div className="mx-auto">
      <div className="grid grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-16 xl:gap-12 lg:gap-10 md:gap-8 sm:gap-6 items-center sm:text-center">

        {/* LEFT SIDE */}
        <div className="py-8 lg:py-6 md:py-4 sm:py-2 sm:text-center sm:items-center sm:px-3">
          <h2 className="font-[Norwester] font-[400] text-white text-[42px] xl:text-[32px] lg:text-[26px] md:text-[24px] sm:text-[22px] tracking-wide uppercase mb-6 sm:mb-4 leading-tight">
            Why Brands Work With Vupop
          </h2>

          <p className="font-[Inter] text-left text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed mb-6 sm:mb-4">
            Brands choose Vupop because it:
          </p>

          <ul className="font-[Inter] text-left text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed pl-4 space-y-3 text-[#C4C7CC] mb-8 sm:mb-6 list-disc">
            <li>Turns audiences into participants</li>
            <li>Enriches marketing campaigns with authenticity</li>
            <li>Encourages real engagement</li>
            <li>Supports structured fan rewards</li>
            <li>Connects brands with communities</li>
            <li>Aligns with modern digital behaviour</li>
          </ul>

          <p className="font-[Inter] text-left text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] mt-3 leading-relaxed max-w-4xl xl:max-w-xl lg:max-w-full">
            Vupop helps brands move from attention to participation
          </p>
        </div>

        {/* RIGHT SIDE */}
        <div className="w-full">
          <div className="w-full rounded-[20px] flex items-center justify-center">
            <img src={bgi3} alt="Broadcasters" className="w-full h-auto bg-cover rounded-[20px]" />
          </div>
        </div>

      </div>
    </div>
  </section>
);
}